// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4cf3b0176db546354243cde290a1fb6ee7c682e2/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};